import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';
import { SlashMenuConfigExtension } from '@blocksuite/affine-widget-slash-menu';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import { literal } from 'lit/static-html.js';

import { RichTableConvertToolbarExtension } from './configs/convert-toolbar.js';
import { richTableSlashMenuConfig } from './configs/slash-menu.js';
import { effects } from './effects.js';
import { RichTableKeymapExtension } from './rich-table-keymap.js';

export class RichTableViewExtension extends ViewExtensionProvider {
  override name = 'affine-rich-table-block';

  override effect() {
    super.effect();
    effects();
  }

  override setup(context: ViewExtensionContext) {
    super.setup(context);
    context.register([
      FlavourExtension('affine:rich-table'),
      FlavourExtension('affine:rich-table-row'),
      FlavourExtension('affine:rich-table-cell'),
      BlockViewExtension('affine:rich-table', literal`affine-rich-table`),
      BlockViewExtension(
        'affine:rich-table-row',
        literal`affine-rich-table-row`
      ),
      BlockViewExtension(
        'affine:rich-table-cell',
        literal`affine-rich-table-cell`
      ),
      RichTableKeymapExtension,
      SlashMenuConfigExtension('affine:rich-table', richTableSlashMenuConfig),
      RichTableConvertToolbarExtension,
    ]);
  }
}
